import { render, staticRenderFns } from "./edit.content-sections.page.vue?vue&type=template&id=10027baa&scoped=true&"
import script from "./edit.content-sections.page.vue?vue&type=script&lang=js&"
export * from "./edit.content-sections.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10027baa",
  null
  
)

export default component.exports